import { Alert, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import useAuditStore from "./useAuditStore";
import SwitchButton from "./SwitchButton";
import score from "./score";
import { Check, Warning } from "@mui/icons-material";

export default function Results(){

    const {audit, tab} = useAuditStore()
    
    return <>

        {tab === 'initial' &&
            <Alert severity='info' sx={{mb: 1}}>
                La part de réponses "OUI" traduisent de la mise en place des pratiques attendues ou recommandées, tandis que les réponses "NON", révèlent les difficultés rencontrées et le décalage entre votre pratique réelle observée et les recommandations en vigueur.
            </Alert>
        }

        {tab === 'final' &&
            <Alert severity='info' sx={{mb: 1}}>
                Cette réévaluation permet de suivre l'efficacité des actions d'amélioration des pratiques mises en œuvre. Une amélioration de vos pratiques par rapport au résultat de votre audit clinique intial sera signalée par le symbole <Check color='success' sx={{ml: 1}}/> alors qu'une régression sera signalée par le symbole <Warning color='error' sx={{ml: 1}} />
            </Alert>
        }
    
        <Paper variant='outlined'>

            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell><b>Question</b></TableCell>
                            <TableCell><b>OUI</b></TableCell>
                            <TableCell><b>NON</b></TableCell>
                            {tab === 'final' &&
                                <TableCell></TableCell>
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {audit.map((row, i) =>
                            <TableRow key={i}>
                                <TableCell><b>{i + 1}</b></TableCell>
                                <TableCell>{row.question.title}</TableCell>
                                <TableCell>
                                    {score(row, tab, 'OUI')}<small>%</small>
                                </TableCell>
                                <TableCell>
                                    {score(row, tab, 'NON')}<small>%</small>
                                </TableCell>

                                {tab === 'final' &&

                                    <TableCell width={20}>
                                        {(score(row, 'final', 'OUI') < 100 && score(row, 'final', 'OUI') <= score(row, 'initial', 'OUI')) &&
                                            <Warning color='error' />
                                        }
                                        {score(row, 'final', 'OUI') > score(row, 'initial', 'OUI') &&
                                            <Check color='success' />
                                        }
                                    </TableCell>
                                }

                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

        </Paper>
        
        <SwitchButton />
        
    </>
}